import { Media } from 'assets/Mixins.style';
import { css } from 'styled-components';

export const Button = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 177px;
  height: auto;
  min-height: 46px;
  transition: 0.2s all;
  border: 0;
  border-radius: ${props =>
    `${
      props.theme.borderRadius && props.theme.borderRadius.default
        ? props.theme.borderRadius.default
        : '4px'
    }`};
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: pointer;
  margin: ${props => props.theme.margin};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  ${props =>
    props.invert &&
    css`
      background: transparent;
      border: 1px solid ${props => props.theme.background};
      color: ${props => props.theme.background};
    `}

    &:hover {
    background: ${props => props.theme.backgroundOnHover};
    color: ${props => props.theme.colorOnHover};

    & svg {
      color: ${props => props.theme.colorOnHover};
    }

    ${props =>
      props.invert &&
      css`
        background: transparent;
        border: 1px solid ${props => props.theme.backgroundOnHover};
        color: ${props => props.theme.backgroundOnHover};
      `}

  }
`;

export const ButtonIcon = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${props => props.theme.minWidth};
  min-height: ${props => props.theme.minHeight};
  margin: ${props => props.theme.margin.default};
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  vertical-align: middle;
  border-radius: ${props => props.theme.borderRadius.default};
  transition: 0.2s all;

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    border-radius: ${props => props.theme.borderRadius.md};
  `}
`;
